function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Diabetes");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "prefix_Group_2487",
  "data-name": "prefix  Group 2487"
}, /*#__PURE__*/React.createElement("path", {
  id: "prefix_Path_3538",
  "data-name": "prefix  Path 3538",
  className: "st1",
  d: "M32.94,30A2.71,2.71,0,0,0,35,26.79a3.15,3.15,0,0,0-.23-.65,2.71,2.71,0,0,0,2-2.61,2.62,2.62,0,0,0-.25-1.13H41A2.72,2.72,0,0,0,41,17H31.09l-.63-1.78a3.88,3.88,0,0,0-4.08-2.56,26.25,26.25,0,0,0-6.63,1.31c-2.27.86-4.78,4.65-5.59,5.95h-1a.8.8,0,0,0-.87.72.78.78,0,0,0,.71.87.43.43,0,0,0,.16,0h1.4a.79.79,0,0,0,.69-.39c.8-1.35,3.27-5,5-5.66l.05,0a24.52,24.52,0,0,1,6.17-1.2A2.3,2.3,0,0,1,29,15.71L29.4,17H25.59l-.41-.52a.8.8,0,0,0-1.35.86.64.64,0,0,0,.1.13l.65.82a.8.8,0,0,0,.63.3H41a1.13,1.13,0,0,1,0,2.25L30,20.82a.8.8,0,0,0,0,1.59h4a1.13,1.13,0,0,1,0,2.25H30a.8.8,0,0,0,0,1.59h2.32a1.13,1.13,0,0,1,0,2.25H30a.8.8,0,0,0,0,1.59h.48a1.13,1.13,0,0,1,0,2.25H22.77s-2,.27-5-1.93a.78.78,0,0,0-.47-.15H13.26a.78.78,0,0,0-.71.87.81.81,0,0,0,.71.72h3.8A9.64,9.64,0,0,0,22.54,34a1.88,1.88,0,0,0,.41,0H30.5a2.71,2.71,0,0,0,2.72-2.71,2.61,2.61,0,0,0-.28-1.2Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix_Path_3539",
  "data-name": "prefix  Path 3539",
  className: "st1",
  d: "M40.3,24.92a.81.81,0,0,0-.68-.37.82.82,0,0,0-.68.37L36.79,28.4A3.92,3.92,0,0,0,36.12,31a3.53,3.53,0,0,0,7-.44,3.93,3.93,0,0,0-.68-2.08Zm.61,7a1.92,1.92,0,0,1-2.73-.15,2,2,0,0,1-.48-1.05,2.34,2.34,0,0,1,.45-1.51l1.47-2.38,1.49,2.4a2.37,2.37,0,0,1,.45,1.25A1.93,1.93,0,0,1,40.91,32Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix_Path_3540",
  "data-name": "prefix  Path 3540",
  className: "st1",
  d: "M35,38.67H33.53V37.24a.79.79,0,0,0-.87-.71.81.81,0,0,0-.72.71v1.43H30.52a.8.8,0,0,0-.72.87.81.81,0,0,0,.72.72h1.42v1.42a.81.81,0,0,0,.88.72.79.79,0,0,0,.71-.72V40.26H35a.79.79,0,0,0,.71-.88.81.81,0,0,0-.71-.71Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix_Path_3541",
  "data-name": "prefix  Path 3541",
  className: "st1",
  d: "M21.66,38.67H17.22a.78.78,0,0,0-.71.87.8.8,0,0,0,.71.72h4.44a.81.81,0,0,0,.88-.72.8.8,0,0,0-.72-.87A.43.43,0,0,0,21.66,38.67Z"
}));

var SvgDiabetes = function SvgDiabetes(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "id-icon-diabetes",
    "data-name": "Layer 1",
    viewBox: "0 0 55 55",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDiabetes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/diabetes.ad73cd60.svg";
export { ForwardRef as ReactComponent };